import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import classname from 'classnames';

export class Textinput extends PureComponent {
  onChangeHandler = (event) => {
    const { fieldName, normalizeField, definition, onChangeHandler } = this.props;

    const normalizedValue = normalizeField(event.target.value, definition);
    onChangeHandler({ [fieldName]: normalizedValue });
  };

  render() {
    const {
      id,
      definition,
      input: { onBlur },
      className,
    } = this.props;

    return (
      <input
        id={id}
        type="tel"
        value={definition}
        onChange={this.onChangeHandler}
        onBlur={onBlur}
        className={classname(className)}
      />
    );
  }
}

Textinput.propTypes = {
  id: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  definition: PropTypes.string,
  input: PropTypes.shape({
    onBlur: PropTypes.func.isRequired,
  }).isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  onChangeHandler: PropTypes.func.isRequired,
  normalizeField: PropTypes.func.isRequired,
};

Textinput.defaultProps = {
  className: '',
  definition: '',
};
